var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "operations",
          staticStyle: {
            width: "280px",
            "margin-top": "5px",
            "margin-left": "5px"
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.isEdit,
                no: "openInsure",
                type: "primary"
              },
              on: { click: _vm.openInsure }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
          )
        ],
        1
      ),
      _c("div", { staticStyle: { display: "flex", "flex-grow": "1" } }, [
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: { width: "220px", flex: "none" }
          },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                "show-side-bar": false,
                "grid-options": _vm.left.gridOptions,
                "grid-params": _vm.gridParams,
                "column-defs": _vm.leftColumnDefs,
                "row-data": _vm.left.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  _vm.left.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: { "margin-left": "10px", flex: "1" }
          },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                "config-module": "1300012",
                "grid-options": _vm.right.gridOptions,
                "grid-params": _vm.gridParams,
                "column-defs": _vm.rightColumnDefs,
                "row-data": _vm.right.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  _vm.right.gridApi = params.api
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "cargo-dialog",
        {
          attrs: {
            title: _vm.$t("FileHistory.preview"),
            visible: _vm.previewFileData.visible,
            "can-maximize": true,
            "custom-class": "preview-dialog"
          },
          on: { close: _vm.closePreviewDialog }
        },
        [
          _c(
            "div",
            [
              _c("p", { staticStyle: { "text-align": "center" } }, [
                _c(
                  "span",
                  {
                    staticClass: "turn",
                    class: { grey: _vm.previewFileData.currentPage == 1 },
                    on: {
                      click: function($event) {
                        return _vm.changePdfPage(0)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Pre")))]
                ),
                _vm._v(
                  " " +
                    _vm._s(_vm.previewFileData.currentPage) +
                    " / " +
                    _vm._s(_vm.previewFileData.numPages) +
                    " "
                ),
                _c(
                  "span",
                  {
                    staticClass: "turn",
                    class: {
                      grey:
                        _vm.previewFileData.currentPage ==
                        _vm.previewFileData.numPages
                    },
                    on: {
                      click: function($event) {
                        return _vm.changePdfPage(1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Next")))]
                )
              ]),
              _c("pdf", {
                attrs: {
                  src: _vm.previewFileData.pdfSrc,
                  page: _vm.previewFileData.currentPage
                },
                on: {
                  "num-pages": function($event) {
                    _vm.previewFileData.numPages = $event
                  },
                  "page-loaded": function($event) {
                    _vm.previewFileData.currentPage = $event
                  },
                  loaded: _vm.loadPdfHandler
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }